import { message } from 'antd';
import { narAppStorageKey } from '../constants/session-storage/auth';
import { LocalstorageService } from './localstorage-service';
import { AuthMessages } from "../constants/messages";
import { PublicClientApplication } from '@azure/msal-browser';
import authAPI from '../integrations/AuthAPI';
import { adClientId, adTenantId, adScope } from 'integrations/Defaults';

const msalConfig = {
  auth: {
    clientId: adClientId,
    authority: `https://login.microsoftonline.com/${adTenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);
const redirectHandlerPromise = msalInstance.handleRedirectPromise();
const loginRequest = {
  scopes: [adScope, 'openid', 'profile', 'User.Read'],
  prompt: 'select_account',
  loginHint: '',
};

class AuthService {
  static LoginResponseHandler(responseData, errorCallback = () => { }) {
    const { mensagens, dados } = responseData;

    if (dados && dados.token) {
      LocalstorageService.setData(narAppStorageKey, dados);
      message.success(AuthMessages.successAuthentication);
      return true;
    }

    if (mensagens && mensagens.length) {
      mensagens.forEach(messageStr => {
        if (!dados || !dados.token) {
          errorCallback(messageStr);
        } else {
          message.success(messageStr);
        }
      });
    }

    return false;
  }

  static async LoginAD(recaptchaToken) {
    sessionStorage.setItem('recaptchaToken', recaptchaToken);
    await msalInstance.loginRedirect(loginRequest);
  }


  static async HandleRedirectCallback(errorCallback = () => { }) {

    const redirectResponse = await redirectHandlerPromise;

    if (!redirectResponse) {
      return null;
    }

    const recaptchaToken = sessionStorage.getItem('recaptchaToken');

    const responseData = await authAPI.loginAd(redirectResponse.accessToken, recaptchaToken);

    return AuthService.LoginResponseHandler(responseData, errorCallback);
  }
}

export default AuthService;
